import { create } from 'zustand';

import { type DateRangeFilter } from '@/utils/constants';

interface NarrativeStore {
  activeFilter: DateRangeFilter;
  setActiveFilter: (filter: DateRangeFilter) => void;
}

export const useNarrativeStore = create<NarrativeStore>((set) => ({
  activeFilter: 'today',
  setActiveFilter: (filter) => set({ activeFilter: filter }),
}));
